import { render, staticRenderFns } from "./jlkButtonText.vue?vue&type=template&id=7bec1162"
import script from "./jlkButtonText.vue?vue&type=script&lang=js"
export * from "./jlkButtonText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports